import { TranslateService } from '@ngx-translate/core';

export class FlowControl {
    id: number | null = null;
    userId: number | null = null;
    firstName: string | null = null;
    lastName: string | null = null;
    date: string | null = null;
    action: string | null = null; 
    animalName: string | null = null;
    animalId: number | null = null;

    getLabel(translate: TranslateService): string {
        let ret = translate.instant('Shelter entrance')
        if(this.action == 'exitShelter')
            ret = translate.instant('Shelter exit')
        if(this.action == 'enterOrExitShelter')
            ret = translate.instant('Shelter entrance / exit')
        else if(this.action == 'startWalk')
            ret = translate.instant('Start of walk')
        else if(this.action == 'endWalk')
            ret = translate.instant('End of walk')
        else if(this.action == 'startOrEndWalk')
            ret = translate.instant('Start / End of walk')
        else if(this.action == 'meal')
            ret = translate.instant('Meal')
        else if(this.action == 'startTemporaryAdoption')
            ret = translate.instant('Start of temporary adoption')
        else if(this.action == 'endTemporaryAdoption')
            ret = translate.instant('End of temporary adoption')
        else if(this.action == 'organizationDateEntry')
            ret = translate.instant('Entry to the shelter')
        else if(this.action == 'organizationDateExit')
            ret = translate.instant('Leaving the shelter / Adoption')
        return ret
    }
    
    getIcon(): string {
        if(['enterShelter', "endWalk", "endTemporaryAdoption", "organizationDateEntry"].includes(this.action ?? ''))
            return 'arrow-down-circle-outline'
        else if(['meal'].includes(this.action ?? ''))
            return 'pizza-outline'
        else
            return 'arrow-up-circle-outline'
    }

    getIconColor(): string {
        if(['meal'].includes(this.action ?? ''))
            return 'primary'
        else if(['meal', 'enterShelter', "startWalk", "startTemporaryAdoption", "organizationDateEntry"].includes(this.action ?? ''))
            return 'success'
        else
            return 'danger'
    }
}